import { Observable } from 'rxjs';
import { ChatFormTenantResolver } from '@nimbus-global/features/chat-form/models/chat-form-tenant-resolver';
import { IChatFormFieldAction } from '@nimbus-global/features/chat-form/models/chat-form-resolver.model';
import { CompanionReferenceType, ICompanionReference } from '@nimbus-library/features/companion-chat/models/companion-conversation.model';
import { IChatFormEntityHandler } from './form-entity-handlers/i-chat-form-entity-handler';

export abstract class CompanionChatResolver {
  public abstract readonly resolveTenant: ChatFormTenantResolver;
  public abstract readonly formResolvers: IChatFormEntityHandler[];
  public notifyEntityChanged?(kind: CompanionReferenceType): void;
  public resolveReferenceLink?(reference: ICompanionReference): Observable<IChatFormFieldAction>;
}
